import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAllAircraft } from '../services/api';
import securityIcon from '../assets/icons/security.svg';
import './LoginPage.css';

const LoginPage = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();

  const [aircraft, setAircraft] = useState([]);
  const [form, setForm] = useState({ email: '', aircraft_id: '', personal_id: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [acLoading, setAcLoading] = useState(true);

  useEffect(() => {
    if (user) navigate('/dashboard');
  }, [user, navigate]);

  useEffect(() => {
    getAllAircraft()
      .then(res => setAircraft(res.data.aircraft || []))
      .catch(() => setAircraft([]))
      .finally(() => setAcLoading(false));
  }, []);

  const validate = () => {
    const e = {};
    if (!form.email.trim()) e.email = 'Username is required';
    if (!form.aircraft_id) e.aircraft_id = 'Please select an aircraft';
    if (!form.personal_id.trim()) e.personal_id = 'One-Time Password is required';
    return e;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    setErrors(er => ({ ...er, [name]: '' }));
    setLoginError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    setLoading(true);
    const result = await login(form.email, form.aircraft_id, form.personal_id);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setLoginError(result.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1 className="login-title">TECHNICAL LOGBOOK</h1>
        </div>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          {loginError && (
            <div className="login-error">{loginError}</div>
          )}

          <div className="login-field">
            <label className="login-label">Username</label>
            <input
              name="email"
              type="text"
              className={`form-input ${errors.email ? 'error' : ''}`}
              value={form.email}
              onChange={handleChange}
              autoComplete="username"
            />
            {errors.email && <span className="field-error">{errors.email}</span>}
          </div>

          <div className="login-field">
            <label className="login-label">Aircraft</label>
            <select
              name="aircraft_id"
              className={`form-select ui-dropdown ${errors.aircraft_id ? 'error' : ''}`}
              value={form.aircraft_id}
              onChange={handleChange}
              disabled={acLoading}
            >
              <option value="">
                {acLoading ? 'Loading aircraft...' : 'Select aircraft'}
              </option>
              {aircraft.map(ac => (
                <option key={ac.id} value={ac.id}>
                  {ac.registration} — {ac.ac_type}
                </option>
              ))}
            </select>
            {errors.aircraft_id && <span className="field-error">{errors.aircraft_id}</span>}
          </div>

          <div className="login-field">
            <label className="login-label">One-Time Password</label>
            <input
              name="personal_id"
              type="password"
              className={`form-input ${errors.personal_id ? 'error' : ''}`}
              value={form.personal_id}
              onChange={handleChange}
              autoComplete="current-password"
            />
            {errors.personal_id && <span className="field-error">{errors.personal_id}</span>}
          </div>

          <button type="submit" className="login-submit" disabled={loading}>
            {loading ? (
              <>
                <div className="spinner" />
                Signing in…
              </>
            ) : (
              <>
                <img src={securityIcon} alt="" className="login-submit-icon" />
                Sign In
              </>
            )}
          </button>

          <div className="login-offline">
            <label>
              <input type="checkbox" className="offline-check" disabled />
              <span>Offline Login</span>
            </label>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;


